<template>
  <div>
    <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
      <h4 class="panel-title">{{ $t('reports.customerInvoicesReportTitle') }}</h4>
      <img src="../../../assets/images/black_shipzone.png" class="print-only" style="height:40px;" alt="Lasshopping" />
    </div>
    <div class="panel-body" style="display: block">
      <div class="row mb-3 no-print">
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <v-select
            autocomplete
            :items="customers"
            v-model="selectedCustomer"
            item-text="text"
            item-value="value"
            :label="$t('columns.customer')"
            hide-details
            clearable
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="startTime"
            :option="fromOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
          <date-picker
            style="margin-top: 4%; border-bottom-color: #919191"
            :date="endTime"
            :option="toOption"
            class="form-control"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3" style="display:flex; align-items:center; flex-wrap:nowrap; gap:8px;">
          <v-btn style="height: auto" @click="getData()" depressed :loading="loading">
            &nbsp; {{ $t('reports.apply') }}
          </v-btn>
          <v-btn v-if="rows.length" class="no-print" @click="printReport()" color="blue-grey" dark small style="height:auto;">
            <v-icon left small>print</v-icon> {{ $t('reports.printReport') }}
          </v-btn>
          <p v-if="rows.length" class="print-only"><strong>{{ $t('reports.periodColon') }} {{ startTime.time }} &mdash; {{ endTime.time }}</strong></p>
        </div>
      </div>

      <table v-if="rows.length" class="table table-bordered">
        <thead style="background-color:#4A8AF4; color:#fff;">
          <tr>
            <th rowspan="2" style="vertical-align:middle;">#</th>
            <th rowspan="2" style="vertical-align:middle;">{{ $t('columns.customerName') }}</th>
            <th colspan="4" style="text-align:center; color:#ff6b6b;">{{ $t('reports.notPaidHeader') }}<span class="col-sub">{{ $t('reports.notPaidSubLabel') }}</span></th>
            <th colspan="4" style="text-align:center; color:#ffcc02;">{{ $t('reports.partialPaidHeader') }}<span class="col-sub">{{ $t('reports.partialPaidSubLabel') }}</span></th>
            <th colspan="4" style="text-align:center; color:#69db7c;">{{ $t('reports.paid') }}<span class="col-sub">{{ $t('reports.paidSubLabel') }}</span></th>
          </tr>
          <tr style="background-color:#3a7ae4;">
            <th>{{ $t('reports.count') }}<span class="col-sub"><b>N</b> {{ $t('reports.equalsInvoiceCount') }}</span></th><th>{{ $t('columns.total') }} ($)<span class="col-sub"><b>A</b> {{ $t('reports.equalsSigmaInvoiceAmount') }}</span></th><th>{{ $t('reports.paid') }} ($)<span class="col-sub"><b>B</b> {{ $t('reports.equalsSigmaAmountPaid') }}</span></th><th>{{ $t('columns.remaining') }} ($)<span class="col-sub"><b>C</b> = A &minus; B</span></th>
            <th>{{ $t('reports.count') }}<span class="col-sub"><b>N</b> {{ $t('reports.equalsInvoiceCount') }}</span></th><th>{{ $t('columns.total') }} ($)<span class="col-sub"><b>A</b> {{ $t('reports.equalsSigmaInvoiceAmount') }}</span></th><th>{{ $t('reports.paid') }} ($)<span class="col-sub"><b>B</b> {{ $t('reports.equalsSigmaAmountPaid') }}</span></th><th>{{ $t('columns.remaining') }} ($)<span class="col-sub"><b>C</b> = A &minus; B</span></th>
            <th>{{ $t('reports.count') }}<span class="col-sub"><b>N</b> {{ $t('reports.equalsInvoiceCount') }}</span></th><th>{{ $t('columns.total') }} ($)<span class="col-sub"><b>A</b> {{ $t('reports.equalsSigmaInvoiceAmount') }}</span></th><th>{{ $t('reports.paid') }} ($)<span class="col-sub"><b>B</b> {{ $t('reports.equalsSigmaAmountPaid') }}</span></th><th>{{ $t('columns.remaining') }} ($)<span class="col-sub"><b>C</b> = A &minus; B</span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in rows" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.full_name }}</td>
            <td style="color:red; font-weight:bold;">{{ item.not_paid_count }}</td>
            <td>${{ fmt(item.not_paid_total_amount) }}</td>
            <td style="color:green;">${{ fmt(item.not_paid_paid_amount) }}</td>
            <td style="color:red;">${{ fmt(item.not_paid_remaining) }}</td>
            <td style="color:#f57c00; font-weight:bold;">{{ item.partial_paid_count }}</td>
            <td>${{ fmt(item.partial_paid_total_amount) }}</td>
            <td style="color:green;">${{ fmt(item.partial_paid_paid_amount) }}</td>
            <td style="color:red;">${{ fmt(item.partial_paid_remaining) }}</td>
            <td style="color:green; font-weight:bold;">{{ item.paid_count }}</td>
            <td>${{ fmt(item.paid_total_amount) }}</td>
            <td style="color:green;">${{ fmt(item.paid_paid_amount) }}</td>
            <td style="color:red;">${{ fmt(item.paid_remaining) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import myDatepicker from 'vue-datepicker'

export default {
  components: { 'date-picker': myDatepicker },
  data() {
    return {
      loading: false,
      customers: [{ value: 'all', text: this.$t('reports.allCustomersOption') }],
      selectedCustomer: 'all',
      rows: [],
      startTime: { time: '' },
      endTime: { time: '' },
      headers: [
        { text: 'Customer', value: 'full_name' },
        { text: 'Total Inv.', value: 'invoice_count' },
        { text: 'Not Paid', value: 'not_paid_count' },
        { text: 'Partial Paid', value: 'partial_paid_count' },
        { text: 'Paid', value: 'paid_count' },
        { text: 'Total ($)', value: 'total_amount' },
        { text: 'Paid ($)', value: 'total_paid' },
        { text: 'Remaining ($)', value: 'total_remaining' }
      ],
      fromOption: this.$_datepickerOption(this.$t('columns.fromDate')),
      toOption: this.$_datepickerOption(this.$t('columns.toDate'))
    }
  },
  mounted() {
    this.initCurrentMonth()
    this.loadCustomers()
  },
  methods: {
    initCurrentMonth() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const lastDay = new Date(y, now.getMonth() + 1, 0).getDate()
      this.startTime.time = `${y}-${m}-01`
      this.endTime.time = `${y}-${m}-${String(lastDay).padStart(2, '0')}`
    },
    loadCustomers() {
      const token = localStorage.getItem('access_token')
      axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then(res => {
          const list = (res.data.data || []).map(c => ({
            value: c.user_id,
            text: c.full_name + ' - ' + this.$t('reports.telColonPrefix') + [c.phone_number, c.phone_number_2].filter(Boolean).join(' / ')
          }))
          this.customers = [{ value: 'all', text: this.$t('reports.allCustomersOption') }, ...list]
        })
        .catch(() => {})
    },
    getData() {
      if (!this.startTime.time || !this.endTime.time) {
        swal(this.$t('common.error'), this.$t('reports.pleaseSelectFromToDate'), 'error')
        return
      }
      this.loading = true
      const token = localStorage.getItem('access_token')
      axios
        .post('api/report/customer-invoices', {
          customer_id: this.selectedCustomer,
          from_date: this.startTime.time,
          to_date: this.endTime.time
        }, { headers: { Authorization: 'Bearer ' + token } })
        .then(res => { this.rows = res.data.rows })
        .catch(() => swal(this.$t('common.error'), this.$t('reports.failedToLoadReport'), 'error'))
        .finally(() => { this.loading = false })
    },
    fmt(v) {
      return parseFloat(v || 0).toFixed(2)
    },
    printReport() { window.print() },
    $_datepickerOption(placeholder) {
      return {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: ['January','February','March','April','May','June','July','August','September','October','November','December'],
        format: 'YYYY-MM-DD',
        placeholder,
        inputStyle: { display: 'inline-block', padding: '6px', 'line-height': '22px', 'font-size': '16px', color: '#2d2d2d', width: '100%' },
        color: { header: '#80864D', headerText: '#ffffff' },
        overlayOpacity: 0.5,
        dismissible: true
      }
    }
  }
}
</script>

<style>
.col-sub {
  display: block;
  font-weight: 400;
  font-size: 10px;
  opacity: 0.85;
  line-height: 1.2;
  margin-top: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/report/customerInvoicesReport.vue